module.exports = __webpack_public_path__ + "assets/img/57@3x.d4c666ac.png";